import { createElement, type ReactNode } from "react";
import {
  Boxes,
  CalendarDays,
  FileText,
  Github,
  Instagram,
  Mail,
  Megaphone,
  MessageCircle,
  Youtube,
  Webhook,
} from "lucide-react";
import type { IntegrationKind } from "@lumen/shared";

export function iconFor(kind: IntegrationKind, size = 19): ReactNode {
  if (kind === "mailbox") return createElement(Mail, { size });
  if (kind === "webhook") return createElement(Webhook, { size });
  if (kind === "google_calendar" || kind === "microsoft_calendar")
    return createElement(CalendarDays, { size });
  if (kind === "google_drive" || kind === "sharepoint" || kind === "notion")
    return createElement(FileText, { size });
  if (
    kind === "github" ||
    kind === "gitlab" ||
    kind === "codeberg" ||
    kind === "gitea"
  )
    return createElement(Github, { size });
  if (kind === "instagram_business") return createElement(Instagram, { size });
  if (kind === "youtube") return createElement(Youtube, { size });
  if (["whatsapp", "telegram", "slack", "teams", "sms", "voice"].includes(kind))
    return createElement(MessageCircle, { size });
  if (
    ["facebook_pages", "linkedin", "tiktok", "x", "email_marketing"].includes(
      kind,
    )
  )
    return createElement(Megaphone, { size });
  return createElement(Boxes, { size });
}
